import React from 'react';

const ComingSoon = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[calc(100vh-200px)] text-center">
      <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Coming Soon</h1>
      <p className="text-lg md:text-xl text-gray-600 mb-8">This feature is under construction. We're working hard to bring it to you soon!</p>
      <div className="text-6xl md:text-7xl">🚧</div>
    </div>
  );
};

export default ComingSoon;
